import { lazyClearSearchBox, lazyEndSearchSession, lazyIsSearchBoxEmpty, lazyRemoveSuggestionPillFromSearchBox, lazySetIsFocusInSearchInput, lazySetSpellerData, } from '../index';
/**
 * This helper function is called after a search session starts, and helps pre-load
 * lazily loaded imports to improve the user experience.
 */
export default function importLazyImports() {
    lazyClearSearchBox.import();
    lazyEndSearchSession.import();
    lazyIsSearchBoxEmpty.import();
    lazyRemoveSuggestionPillFromSearchBox.import();
    lazySetIsFocusInSearchInput.import();
    lazySetSpellerData.import();
}
//# sourceMappingURL=importLazyImports.js.map